import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.user-accounts.import', {
        url: '/import',
        views: {
            '@user': 'userPasswordManagerImport',
        },
        resolve: {importFileTypes},
    });
}

/** @ngInject */
function importFileTypes(PasswordManagers) {
    return PasswordManagers.getImportFileTypes();
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/import/import.state.js